import React from 'react';
import { ICustomerLocalizationGroup } from 'types';
import { FormSection } from 'components/EntityForm/FormSection';
import { LocalizationItem } from './LocalizationItem';

interface IProps {
	group: ICustomerLocalizationGroup;
	languageId: string;
}

export const LocalizationGroup: React.FC<IProps> = ({ group, languageId }) => (
	<FormSection
		translationKey={group.name || ''}
		translationNameSpace="localizationSettings"
		testId="LocalizationGroup"
		isCollapsible={false}>
		<div className="-mx-4 flex flex-wrap gap-y-4">
			{group.items.map((el) => (
				<div key={el.key} className="w-1/2 px-4">
					<LocalizationItem groupId={group.id} item={el} languageId={languageId} />
				</div>
			))}
		</div>
	</FormSection>
);
